import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoutingComponent } from './routing.component';
import {ArmSideNavModule} from '../../components/arm-side-nav/arm-side-nav.module';
import { QualityBasedRoutingComponent } from './quality-based-routing/quality-based-routing.component';
import {ArmFormModule} from '../../components/arm-form/arm-form.module';
import {MaterialModule} from '../../material.module';
import {FormsModule} from '@angular/forms';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import { GlobalRoutingSettingsComponent } from './global-routing-settings/global-routing-settings.component';
import {ArmFormTitleModule} from '../../components/arm-form/arm-form-title/arm-form-title.module';
import { RegistrationRoutingSettingComponent } from './registration-routing-setting/registration-routing-setting.component';
import {InfraModule} from 'ac-infra';
import { CacProfilesComponent } from './cac-profiles/cac-profiles.component';
import { CacProfilesDialogComponent } from './cac-profiles/cac-profiles-dialog/cac-profiles-dialog.component';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import { CacProfilesConfigurationComponent } from './cac-profiles/cac-profiles-configuration/cac-profiles-configuration.component';
import { CallsQuotaComponent } from './calls-quota/calls-quota.component';
import { CallsQuotaConfigurationComponent } from './calls-quota/calls-quota-configuration/calls-quota-configuration.component';
import { CallsQuotaDialogComponent } from './calls-quota/calls-quota-dialog/calls-quota-dialog.component';
import { PeriodicityPipe } from './calls-quota/periodicity.pipe';
import { TimeBasedRoutingComponent } from './time-based-routing/time-based-routing.component';
import { TimeBasedRoutingDialogComponent } from './time-based-routing/time-based-routing-dialog/time-based-routing-dialog.component';
import { AlternativeRoutingSipReasonsComponent } from './alternative-routing-sip-reasons/alternative-routing-sip-reasons.component';
import { AlternativeRoutingSipReasonsDialogComponent } from './alternative-routing-sip-reasons/alternative-routing-sip-reasons-dialog/alternative-routing-sip-reasons-dialog.component';
import { SipReasonGroupDialogComponent } from './alternative-routing-sip-reasons/sip-reason-group-dialog/sip-reason-group-dialog.component';
import {ClientFilterModule} from '../../components/client-filter/client-filter.module';
import { SipReasonGroupDuplicationDialogComponent } from './alternative-routing-sip-reasons/sip-reason-group-duplication-dialog/sip-reason-group-duplication-dialog.component';
import {PipsModule} from '../../pipes/pips.module';
import {AngularSplitModule} from 'angular-split';
import { ShortCallsProfilesComponent } from './short-calls-profiles/short-calls-profiles.component';
import {ShortCallsProfilesDialogComponent} from './short-calls-profiles/short-calls-profiles-dialog/short-calls-profiles-dialog.component';



@NgModule({
  declarations: [RoutingComponent, QualityBasedRoutingComponent, GlobalRoutingSettingsComponent, RegistrationRoutingSettingComponent,
    CacProfilesComponent, CacProfilesDialogComponent, CacProfilesConfigurationComponent,
    CallsQuotaComponent, CallsQuotaConfigurationComponent, CallsQuotaDialogComponent, PeriodicityPipe, TimeBasedRoutingComponent,
    TimeBasedRoutingDialogComponent,
    AlternativeRoutingSipReasonsComponent,
    AlternativeRoutingSipReasonsDialogComponent,
    SipReasonGroupDialogComponent,
    SipReasonGroupDuplicationDialogComponent,
    ShortCallsProfilesComponent,
    ShortCallsProfilesDialogComponent],
  imports: [
    CommonModule,
    ArmSideNavModule,
    ArmFormModule,
    MaterialModule,
    FormsModule,
    NgxSliderModule,
    ArmFormTitleModule,
    InfraModule,
    ActionBarModule,
    ArmTableModule,
    ClientFilterModule,
    PipsModule,
    AngularSplitModule
  ]
})
export class RoutingModule { }
